module.exports = __webpack_public_path__ + "img/xmasParty7.57000a58.jpg";